import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInputExtended, GeneralInputWidthWrapper } from 'src/components';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { FeatureAppEnvironment } from '@feature-hub/core';
import { CloseHandleV2, FocusLayerSizeV2, LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import { useStore } from 'react-redux';
import { AnyAction, Store } from 'redux';
import { LayerManagerWrapper, useFeatureAppEnvironment, useFeatureServices } from 'src/feature-app';

import {
  Container,
  ContainerGutter,
  ContainerPadding,
  ContainerWrap,
  CTA,
  Text,
  TextAppearance,
} from '@volkswagen-onehub/components-core';

interface EdadProps {
  notALayer?: boolean;
}

export const EdadInputText = (props: EdadProps) => {
  const { register, clearError } = useFormContext();
  const [inputValue, setInputValue] = useState('');
  const [pristine, setPristine] = useState(true);
  const regExp = /^(1[89]|[2-9][0-9])$/g;
  const { error, setError } = useOneFormContext();
  const [ageError, setAgeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const store = useStore();
  const env = useFeatureAppEnvironment();
  const layerManager = useFeatureServices()['layer-manager'];

  const isLegalAge = (age: number) => age >= 18;

  const checkAgeError = (value: string) => {
    return !pristine && !regExp.test(value) && value?.length > 1 && !isLegalAge(Number(value));
  };

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
    setPristine(false);
  };

  useEffect(() => {
    if (checkAgeError(inputValue)) {
      if (!isLegalAge(Number(inputValue))) {
        setErrorMessage('Copy mayor de edad');
      } else {
        setErrorMessage('Solo se aceptan números');
      }
      setAgeError(true);
    } else {
      clearError();
      setAgeError(false);
      setError(false);
    }
  }, [inputValue, pristine]);

  useEffect(() => {
    if ((!inputValue && error) || (error && checkAgeError(inputValue))) {
      setAgeError(true);
      renderAvisoMenorDeEdad(store, env, layerManager);
    } else {
      setAgeError(false);
    }
  }, [error]);

  return (
    <GeneralInputWidthWrapper notALayer={props.notALayer}>
      <div style={{ paddingBottom: '1px' }}>
        <TextInputExtended
          name="edad"
          label="Edad"
          isFloating
          innerRef={register({
            required: {
              value: true,
              message: 'Requerido',
            },
            pattern: {
              value: regExp,
              message: 'Solo se aceptan numeros',
            },
          })}
          onChange={(e) => handleChange(e)}
          required
        />
      </div>
      {/*{ageError && <InputError className="input-error">{errorMessage}</InputError>}*/}
    </GeneralInputWidthWrapper>
  );
};



const AvisoMenorDeEdad = ({ close }: { close: CloseHandleV2<any, any> }) => {
  const [href, setHref] = useState(null);
  const [copy, setCopy] = useState(null);

  return (
    <Container
      stretchContent
      padding={{ top: { 0: ContainerPadding.grid002, 960: ContainerPadding.grid001 }, bottom: { 0: ContainerPadding.grid002, 960: ContainerPadding.grid001 }, left: { 0: ContainerPadding.grid002, 960: ContainerPadding.grid001 }, right: { 0: ContainerPadding.grid002, 960: ContainerPadding.grid001 } }}
    >
      <Container
        wrap={ContainerWrap.always}
        stretchContent
        gutter={ContainerGutter.static200}
        padding={{ bottom: ContainerPadding.static350 }}
      >
        <Text bold appearance={TextAppearance.headline0300}>
          Vaya… Todavía no eres mayor de edad
        </Text>
        <Text appearance={TextAppearance.copy200}>
          Y aunque no puedas participar, esperamos que en el futuro podamos ayudarte a vivir cosas fuera de lo común.
        </Text>
      </Container>
      <Container
        wrap={{ 0: ContainerWrap.always, 960: ContainerWrap.never }}
        gutter={{ 0: ContainerGutter.static300, }}
      >
        <CTA tag='a' href='https://www.volkswagen.es/es/modelos/taigo.html' emphasis='primary'>
          Conoce mejor el Nuevo Taigo
        </CTA>
      </Container>
    </Container>
  );
};

const renderAvisoMenorDeEdad = (
  store: Store<any, AnyAction>,
  env: FeatureAppEnvironment<any, any>,
  layerManager: LayerManagerV2
) => {

  const render = (state: any, close: CloseHandleV2<any, any>) => {
    return (
      <LayerManagerWrapper store={store} env={env}>
          <AvisoMenorDeEdad close={close} />
      </LayerManagerWrapper>
  );
  };

  layerManager.openFocusLayer(
    render,
    {},
    { size: FocusLayerSizeV2.B, userCloseable: true }
  );
};

